
import { defineComponent, PropType, computed, ref, onBeforeMount } from "vue";
import CiButton from "@components/base/button.vue";
import CiContentTile from "@components/contents/ContentTile.vue";
import { apiService } from "@services/api.service";

export default defineComponent({
  components: {
    CiContentTile,
    CiButton,
  },
  props: {
    type: {
      type: String as PropType<Nullable<Articles.GroupType>>,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    showCopyright: {
      type: Boolean,
      default: true,
    },
    initialData: {
      type: Object as PropType<{ contents: Articles.TileData[]; meta: PaginationMeta }>,
      default: null,
    },
    contentsFetchMethod: {
      type: Function as PropType<
        (
          type?: Nullable<Articles.GroupType>,
          page?: number,
          per_page?: number
        ) => ApiRequest<{ contents: Articles.TileData[]; meta: PaginationMeta }>
      >,
      default: null,
    },
  },
  setup(props) {
    const contents = ref<Articles.TileData[]>(props.initialData?.contents || []);
    const initialized = ref(false);
    const loading = ref(false);
    const nextPage = ref<number | null>(props.initialData ? props.initialData.meta.next_page : 1);

    const hasContents = computed(() => contents.value.length);
    const lastPageReached = computed(() => !nextPage.value);

    const fetchContents = async () => {
      loading.value = true;

      const { data } = props.contentsFetchMethod
        ? await props.contentsFetchMethod(props.type, nextPage.value || undefined)
        : await apiService.contents.getContentsList(props.type, nextPage.value || undefined);

      contents.value = [...contents.value, ...(data?.contents || [])];
      nextPage.value = data?.meta.next_page || null;
      loading.value = false;
    };

    onBeforeMount(async () => {
      if (!props.initialData) {
        await fetchContents();
      }
      initialized.value = true;
    });

    return {
      contents,
      hasContents,
      initialized,
      loading,
      lastPageReached,
      fetchContents,
    };
  },
});
